export const CogIcon = (props: React.HTMLAttributes<SVGElement>) => {
  const { className, ...rest } = props;

  return (
    <svg
      width='219'
      height='189'
      viewBox='0 0 219 189'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M139.259 0H121.747V16.4425H121.746L121.746 39.8109H121.747V39.8818H124.521C137.911 40.5666 150.613 46.1874 160.139 55.7139C170.322 65.8964 176.042 79.7068 176.042 94.107C176.042 108.507 170.322 122.318 160.139 132.5C149.957 142.683 136.146 148.403 121.746 148.403V171.772C121.746 171.772 121.746 171.772 121.747 171.772V188.564H142.737L145.622 168.011C151.234 166.197 156.628 163.749 161.695 160.71L178.629 174.839C180.218 176.165 182.556 176.06 184.02 174.596L208.536 150.081C209.999 148.617 210.105 146.279 208.779 144.69L192.778 125.513C193.702 123.423 194.533 121.292 195.27 119.128L215.559 116.28C217.534 116.003 219.003 114.314 219.003 112.319V77.2941C219.003 75.2998 217.534 73.6101 215.559 73.3329L195.753 70.5531C195.052 68.3511 194.254 66.1824 193.36 64.0534L209.478 44.7358C210.804 43.1466 210.699 40.8083 209.235 39.3448L184.72 14.829C183.256 13.3654 180.918 13.2601 179.329 14.5861L162.935 28.2643C157.496 24.8617 151.662 22.1502 145.57 20.1868L143.22 3.44405C142.943 1.46907 141.254 0 139.259 0Z'
        fill='#8340A0'
      />
      <circle
        cx='59.8209'
        cy='19.5912'
        r='11.7428'
        stroke='#EA5158'
        strokeWidth='8'
      />
      <circle
        cx='15.7428'
        cy='55.9745'
        r='11.7428'
        stroke='#EA5158'
        strokeWidth='8'
      />
      <circle
        cx='15.7428'
        cy='130.84'
        r='11.7428'
        stroke='#EA5158'
        strokeWidth='8'
      />
      <path
        d='M109.499 23.941C111.708 23.941 113.499 22.1501 113.499 19.941C113.499 17.7319 111.708 15.941 109.499 15.941V23.941ZM72.0664 23.941H109.499V15.941H72.0664V23.941Z'
        fill='#EA5158'
      />
      <circle
        cx='54.2272'
        cy='94.457'
        r='11.7428'
        stroke='#EA5158'
        strokeWidth='8'
      />
      <path
        d='M149.731 98.8068C151.94 98.8068 153.731 97.0159 153.731 94.8068C153.731 92.5977 151.94 90.8068 149.731 90.8068V98.8068ZM66.4688 98.8068H149.731V90.8068H66.4688V98.8068Z'
        fill='#EA5158'
      />
      <path
        d='M31.4844 56.3244H95.3534C97.5625 56.3244 99.3534 58.1152 99.3534 60.3244V66.6678C99.3534 68.877 101.144 70.6678 103.353 70.6678H134.337'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <path
        d='M134.336 116.497H70.4669C68.2578 116.497 66.4669 118.288 66.4669 120.497V126.84C66.4669 129.049 64.6761 130.84 62.4669 130.84H31.4829'
        stroke='#EA5158'
        strokeWidth='8'
        strokeLinecap='round'
      />
      <circle
        cx='61.2194'
        cy='168.623'
        r='11.7428'
        stroke='#EA5158'
        strokeWidth='8'
      />
      <path
        d='M110.902 172.973C113.111 172.973 114.902 171.182 114.902 168.973C114.902 166.764 113.111 164.973 110.902 164.973V172.973ZM73.4688 172.973H110.902V164.973H73.4688V172.973Z'
        fill='#EA5158'
      />
    </svg>
  );
};
